import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-quantity-selector',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './quantity-selector.component.html',
})
export class QuantitySelectorComponent {
  quantity = input.required<number>();
  disabled = input<boolean>(false);
  readOnly = input<boolean>(false);

  increment = output<void>();
  decrement = output<void>();
}
